import { render } from "./DarkModeToggle.vue?vue&type=template&id=11f493e2&ts=true"
import script from "./DarkModeToggle.vue?vue&type=script&lang=ts"
export * from "./DarkModeToggle.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__